<template>
    <div class="Home container">
        <Btn></Btn>
        <div class="cardMemberOfficial">
            <div class="cardWrapper">
                <div @click="$router.go(-1)" class="kembali backBtn text-blue mb-3"><i class="fas fa-chevron-left"></i> Kembali</div>
                 <card-member/>
                <router-link to='registrasi-ulang'>
                <button class="btn-fill blue rounded mt-4">Registrasi Ulang</button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Btn from '../components/backBtn.vue'
import cardMember from '../components/cardMember.vue'
export default {
  components: {
    Btn,
    cardMember
  }
}
</script>

<style lang="scss" scoped>
   @import '../assets/scss/Layout/home.scss';
   .cardMember{
        button{
            font-weight: normal !important;
            font-size: 14px !important;
        }
   }
</style>
